import gql from 'graphql-tag';

export const ADD_MEMBERS_TO_ACTIVATIONS_MUTATION = gql`
  mutation AddMembersToActivationsMutation($query: JSONObject, $memberIds: [Int!], $activationIds: [Int!]!) {
    success: membersAddToActivations(query: $query, memberIds: $memberIds, activationIds: $activationIds)
  }
`;
